import {Address} from "everscale-inpage-provider";

export const AUCTION_ROOT_ADDRESS = new Address('0:d37297b1eba504c3ec3c9d3c4fab7c3d4eb5152e39e380d727705c20fa8a2ff3');
// export const AUCTION_ROOT_ADDRESS = new Address('0:7309068aaddfcee471e6465e99e7a0d1da3464a88fa8b88f36f54d37b831109a');
// export const BASE_SCAN_URL = 'https://everscan.io/'
export const BASE_SCAN_URL = 'https://dev.tonscan.io/'
export const AUCTION_CODE_HASH = '68bbc4b5e9b29c18205f62e51ddefa205d9faaca28798a81b96b0b234c6b78e9'